export const SECTIONS = [
  {
    n: '01',
    t: 'Technology-Related Professional Development',
    p: [
      'Metawave Solutions LLC may coordinate and facilitate general technology-related professional development activities intended to help clients improve their familiarity with commonly used technologies, tools, concepts, methodologies, and industry practices.',
    ],
    leadIn: 'Such activities may include, without limitation:',
    bullets: [
      'General technology-oriented learning sessions and informational workshops',
      'Instructor-led or facilitator-led knowledge-sharing sessions',
      'Technology awareness and skills-development activities',
      'General discussions relating to software development, information technology, data, quality assurance, business analysis, and other commonly used technology disciplines',
      'Practical guidance regarding general technology concepts, tools, processes, and workplace practices',
      'Corporate or professional learning sessions designed to support ongoing skills development',
      'Other informational or professional-development activities agreed upon between Metawave Solutions LLC and the client',
    ],
    note: 'The specific technology topics, learning materials, session formats, duration, frequency, and delivery methods may vary depending on the applicable service arrangement.',
  },
  {
    n: '02',
    t: 'Corporate Learning and Professional Development',
    p: [
      'Metawave Solutions LLC may coordinate and facilitate general professional-development programs and corporate learning activities intended to support workplace effectiveness and professional growth.',
    ],
    leadIn: 'These activities may include:',
    bullets: [
      'Professional communication and workplace communication',
      'Workplace effectiveness and professional conduct',
      'Team collaboration and interpersonal skills',
      'Time-management and organizational skills',
      'General leadership and professional-development concepts',
      'Interview preparation and interview-related guidance',
      'Presentation and professional communication skills',
      'Workplace readiness and professional practices',
      'Other general professional-development topics requested by the client',
    ],
    note: "These services are intended to provide general informational and developmental support and may be customized according to the client's requirements.",
  },
  {
    n: '03',
    t: 'Career Development and Job-Search Support',
    p: [
      'Metawave Solutions LLC may coordinate and provide general career-development and job-search support to individuals seeking to improve their professional readiness and understanding of employment-search practices.',
    ],
    leadIn: 'Such support may include:',
    bullets: [
      'General resume and curriculum vitae preparation guidance',
      'Resume formatting and content suggestions',
      'General interview preparation',
      'Mock interview and interview-practice activities',
      'Guidance regarding professional communication',
      'General job-search strategies and best practices',
      'Professional networking guidance',
      'Guidance regarding commonly used job-search platforms and resources',
      'General career-planning and professional-development discussions',
      'Assistance with identifying areas for skills improvement',
      'Other general career-development activities agreed upon with the client',
    ],
    note: 'Career-development support is intended to assist clients in improving their preparedness and understanding of general job-search practices. Metawave Solutions LLC does not guarantee that participation in any such service will result in an interview, job offer, employment, promotion, compensation, or any other particular career outcome.',
  },
  {
    n: '04',
    t: 'Technical Guidance and Skills Development',
    p: [
      'Metawave Solutions LLC may coordinate general technical guidance, informational resources, and skills-development activities relating to commonly used technologies and industry practices.',
    ],
    leadIn: 'Depending on the applicable service arrangement, such activities may include:',
    bullets: [
      'General explanations of technology concepts and terminology',
      'Skills-development sessions relating to commonly used technology tools and platforms',
      'General industry-practice discussions',
      'Technical knowledge-sharing sessions',
      'Guidance concerning professional technology practices',
      'Informational workshops and demonstrations',
      'General project-oriented learning activities',
      'Other technology-related informational support services',
    ],
    note: 'The services are intended for general learning, informational, and professional-development purposes and should not be interpreted as individualized legal, financial, medical, engineering, or other regulated professional advice.',
  },
  {
    n: '05',
    t: 'Independent Third-Party Service Providers',
    p: [
      'Metawave Solutions LLC may, at its discretion, engage or coordinate with independent third-party instructors, trainers, consultants, technical professionals, subject-matter experts, or other service providers to perform or assist with some or all of the Services.',
      'Where third-party service providers are engaged, such providers may be responsible for delivering particular sessions, workshops, training activities, technical guidance, professional-development activities, or other agreed services.',
      'Third-party service providers are independent professionals and are not necessarily employees of Metawave Solutions LLC. The involvement of an independent service provider does not create an employment, partnership, joint-venture, agency, or other similar relationship between the client and such provider unless expressly agreed in a separate written agreement.',
      'Each independent third-party service provider is responsible for ensuring that the provider possesses and maintains any license, certification, registration, qualification, authorization, or other credential legally required for the specific services performed by that provider.',
    ],
  },
  {
    n: '06',
    t: 'Service Delivery',
    p: [],
    leadIn: 'Services may be delivered through various formats, including, where applicable:',
    bullets: [
      'Online or virtual sessions',
      'Telephone or video conferencing',
      'In-person sessions, where separately agreed',
      'Workshops and informational sessions',
      'One-on-one or small-group sessions',
      'Corporate or organizational sessions',
      'Written or electronic informational materials',
      'Other methods mutually agreed upon by Metawave Solutions LLC and the client',
    ],
    note: 'The availability of a particular delivery method may depend on the nature of the service, the service provider, geographic considerations, scheduling requirements, and the terms of the applicable agreement.',
  },
  {
    n: '07',
    t: 'Scope and Customization of Services',
    p: [
      "The specific services provided to a client may be based on the client's requirements and may be described in a separate service agreement, statement of work, proposal, order form, invoice, engagement letter, or other written communication.",
      'Where applicable, such documentation may specify the services to be provided, applicable fees, scheduling, duration, deliverables, service-provider arrangements, cancellation terms, and other relevant conditions.',
      'Any service not expressly included in the applicable written agreement shall not be deemed to be included merely because it may be related to or complementary to the Services described herein.',
    ],
  },
  {
    n: '08',
    t: 'Informational and Professional-Development Purpose',
    p: [
      'The Services provided by Metawave Solutions LLC are primarily intended for informational, educational-support, professional-development, career-development, and general skills-enhancement purposes.',
      'Information, materials, examples, recommendations, guidance, or other content provided as part of the Services may be based on generally available industry practices and the knowledge or experience of the applicable service provider.',
      'Clients are responsible for evaluating and independently determining how to apply any information or guidance received through the Services to their individual circumstances.',
    ],
  },
  {
    n: '09',
    t: 'No Accredited Education or Certification',
    p: [
      'Unless expressly stated otherwise in a separate written agreement, Metawave Solutions LLC does not operate as an accredited educational institution and does not provide accredited academic degrees, diplomas, vocational qualifications, professional licenses, or government-recognized certifications.',
      'Participation in a workshop, learning session, technical session, professional-development activity, or other Service does not by itself confer an academic degree, accredited qualification, professional license, or government-recognized certification.',
      'Where a certificate of participation, completion, or attendance may be provided, such certificate should not be interpreted as an accredited educational credential or professional certification unless expressly identified as such in writing.',
    ],
  },
  {
    n: '10',
    t: 'No Employment or Placement Guarantee',
    p: [
      'Career-development, job-search, resume, interview-preparation, networking, or professional-development services do not constitute a guarantee of employment or placement.',
    ],
    leadIn: 'Metawave Solutions LLC does not guarantee that a client will:',
    bullets: [
      'Obtain employment',
      'Receive an interview',
      'Receive an employment offer',
      'Receive a particular salary or compensation level',
      'Obtain employment with a particular employer',
      'Obtain a particular position or job title',
      'Receive a promotion or career advancement',
      'Achieve any particular professional or financial result',
    ],
    note: "Employment decisions are made independently by employers and other hiring organizations, and outcomes may depend on numerous factors outside Metawave Solutions LLC's control.",
  },
  {
    n: '11',
    t: 'No Guarantee of Specific Results',
    p: [
      'While Metawave Solutions LLC and its service providers may make reasonable efforts to provide useful and professionally appropriate Services, no representation or guarantee is made regarding any specific result or outcome.',
      "Results may vary depending on the client's existing knowledge, experience, qualifications, participation, effort, market conditions, employer requirements, technology changes, and numerous other factors.",
      'Accordingly, participation in the Services should not be understood as a promise or guarantee of employment, certification, compensation, business opportunity, professional advancement, technical proficiency, or any other specific outcome.',
    ],
  },
  {
    n: '12',
    t: 'Client Responsibility',
    p: [
      'Clients are responsible for providing accurate and complete information where such information is reasonably necessary for the provision of the Services.',
    ],
    leadIn: 'Clients are also responsible for:',
    bullets: [
      'Actively participating in applicable sessions or activities',
      'Reviewing and evaluating information provided through the Services',
      'Completing any activities or assignments associated with the Services',
      'Maintaining the confidentiality of any login credentials or access information provided to them',
      'Ensuring that information supplied by them is accurate and lawful',
      'Making their own professional and career decisions based on their individual circumstances',
    ],
    note: 'Metawave Solutions LLC may rely on information supplied by the client when coordinating or providing Services.',
  },
  {
    n: '13',
    t: 'Third-Party Materials and Services',
    p: [
      'Certain Services may involve third-party platforms, software, websites, learning resources, technology tools, service providers, or other external resources.',
      'Metawave Solutions LLC may provide references to or facilitate access to such resources where appropriate. However, unless expressly agreed otherwise, Metawave Solutions LLC does not control third-party platforms or services and does not necessarily endorse or guarantee their availability, accuracy, security, performance, or suitability.',
      'Clients may be subject to the terms, conditions, privacy policies, and other requirements imposed by applicable third-party providers.',
    ],
  },
  {
    n: '14',
    t: 'Provider Qualifications and Compliance',
    p: [
      'Any independent third-party professional or service provider engaged by Metawave Solutions LLC to perform Services is responsible for maintaining any license, certification, registration, permit, qualification, or other authorization legally required for the particular services provided by that professional or provider.',
      'Where applicable, service providers are expected to perform their services in accordance with applicable laws, regulations, professional requirements, contractual obligations, and generally accepted industry practices.',
    ],
  },
  {
    n: '15',
    t: 'Changes to Services',
    p: [
      'Metawave Solutions LLC reserves the right to modify, update, expand, reduce, suspend, or discontinue particular Services or service offerings from time to time, subject to any applicable contractual obligations.',
      'Any material changes to services already agreed upon with a client may be addressed through the applicable service agreement or other written communication between the parties.',
    ],
  },
  {
    n: '16',
    t: 'No Professional or Regulated Advice',
    p: [
      'Unless expressly agreed in a separate written agreement and provided by an appropriately qualified professional, the Services are not intended to constitute legal, medical, financial, tax, investment, immigration, or other regulated professional advice.',
      'Clients should obtain advice from an appropriately licensed or qualified professional where their circumstances require specialized or regulated professional advice.',
    ],
  },
  {
    n: '17',
    t: 'General Limitation of Expectations',
    p: [
      "Metawave Solutions LLC's role is to coordinate, facilitate, and/or provide general professional-development, technology-related, career-development, and skills-support services as described in the applicable service arrangement.",
      'The Services are not intended to create an expectation that Metawave Solutions LLC will secure employment, provide guaranteed career advancement, provide a specific level of compensation, issue accredited credentials, or achieve any particular result for a client.',
      'By using or engaging Metawave Solutions LLC’s Services, the client acknowledges that professional development and career outcomes depend on multiple factors and that no particular result is guaranteed unless expressly stated in a separate written agreement.',
    ],
  },
  {
    n: '18',
    t: 'Applicable Agreement',
    p: [
      'This Description of Services provides a general description of the types of services that Metawave Solutions LLC may offer or coordinate. The specific terms applicable to a particular client, engagement, service, or transaction shall be governed by the applicable written agreement, statement of work, proposal, order form, engagement letter, or other contractual documentation between Metawave Solutions LLC and the client.',
      'In the event of a conflict between this general Description of Services and a separately executed written agreement, the terms of the applicable written agreement shall control to the extent permitted by applicable law.',
    ],
  },
];
